var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBoxBlank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4102 0.194214C12.8086 0.194214 13.1602 0.346558 13.4648 0.651245C13.7695 0.955933 13.9219 1.3075 13.9219 1.70593V12.1825C13.9219 12.5809 13.7695 12.9325 13.4648 13.2372C13.1602 13.5419 12.8086 13.6942 12.4102 13.6942H1.93359C1.53516 13.6942 1.18359 13.5419 0.878906 13.2372C0.574219 12.9325 0.421875 12.5809 0.421875 12.1825V1.70593C0.421875 1.3075 0.574219 0.955933 0.878906 0.651245C1.18359 0.346558 1.53516 0.194214 1.93359 0.194214H12.4102ZM12.4102 1.70593H1.93359V12.1825H12.4102V1.70593Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxBlank);
export default __webpack_public_path__ + "static/media/check_box_blank.8f7079271856bf26063206d3649b1a9c.svg";
export { ForwardRef as ReactComponent };